import React, { useState } from 'react';
import { Cookie, ChevronDown } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useCookieConsent } from '@auw/workspace-ui';

/** Uses the existing consent provider; presentation belongs to the public landing. */
export const CookieBanner: React.FC = () => {
  const { t } = useTranslation('common');
  const { hasConsented, acceptAll, acceptSelected } = useCookieConsent();
  const [dismissed, setDismissed] = useState(() => hasConsented());
  const [expanded, setExpanded] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const [marketing, setMarketing] = useState(false);
  if (dismissed) return null;
  return <aside className="landing-cookie" aria-label={t('cookieBanner.title', '쿠키 설정')}>
    <div className="landing-cookie-heading"><Cookie size={16} /><p>{t('cookieBanner.barMessage', '서비스 제공 및 개선을 위해 쿠키를 사용합니다.')}</p></div>
    <div className="landing-cookie-actions">
      <button type="button" aria-expanded={expanded} aria-controls="landing-cookie-details" onClick={() => setExpanded(value => !value)}>{t('cookieBanner.settings', '쿠키 설정')}<ChevronDown size={12} /></button>
      <button type="button" onClick={() => { acceptAll(); setDismissed(true); }}>{t('cookieBanner.acceptAll', '모두 허용')}</button>
    </div>
    {expanded && <div className="landing-cookie-details" id="landing-cookie-details">
      {(['necessary', 'analytics', 'marketing'] as const).map(key => <label key={key}><span><strong>{t(`cookieBanner.${key}Label`)}</strong><small>{t(`cookieBanner.${key}Desc`)}</small></span><input type="checkbox" disabled={key === 'necessary'} checked={key === 'necessary' || (key === 'analytics' ? analytics : marketing)} onChange={event => { if (key === 'analytics') setAnalytics(event.target.checked); else if (key === 'marketing') setMarketing(event.target.checked); }} aria-label={t(`cookieBanner.${key}Label`)} /></label>)}
      <button type="button" onClick={() => { acceptSelected({ analytics, marketing }); setDismissed(true); }}>{t('cookieBanner.confirm', '완료')}</button>
    </div>}
  </aside>;
};
